// extracted by mini-css-extract-plugin
export default {"main":"About_main__c1c9+","p":"About_p__tqjpO"};